import React, { useState } from "react";
import { 
    Flex, 
    Table, 
    TableContainer, 
    Tbody, 
    Td, 
    Th, 
    Thead, 
    Tr,
    Button, 
    Tooltip,
    Text,
    Spinner,
} from "@chakra-ui/react";
import { IoPencil, IoTrash } from "react-icons/io5";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";

import api from '../../api';
import { getUsers } from "../../actions/userActions"

const UsersTable = ({
    users,
    loading,
    error,
    currentPage,
    totalPages,
    page,
    setPage,
    openNewUserModal,
    openEditUserModal
}) => {
    const [operationLoading, setOperationLoading] = useState(false);
    const dispatch = useDispatch();

    const deleteUserRequest = async (id) => {
        setOperationLoading(true);
        try{
            const response = await api.delete(`/users/${id}`);
            console.log(response);
            dispatch(getUsers({page: 1, limit: 10}));
            setOperationLoading(false);
            toast.success("Usuario eliminado con éxito.");
        }catch(error){
            console.log(error);
            setOperationLoading(false);
            toast.error("Algo salió mal, inténtalo más tarde.");
        }
    }

    const formatDate = (date) => {
        const newDate = new Date(date);
        const day = newDate.getDate();
        const month = newDate.getMonth() + 1;
        const year = newDate.getFullYear();
        return `${day}/${month}/${year}`;
    }

    if(loading) return (
        <Flex
            mt='20px'
            w="100%"
            h="100%"
            justifyContent="center"
            alignItems="center"
            flexDir='column'
        >   
            <Spinner />
        </Flex>
    )

    if(error) return (
        <Flex
            mt='20px'
            w="100%"
            h="100%"
            justifyContent="center"
            alignItems="center"
            flexDir='column'
        >   
            <Text>Algo salió mal, inténtalo más tarde.</Text>
        </Flex>
    )

    return (
    <Flex
        w="100%"
        flexDir='column'
        alignItems='end'
    >
        <TableContainer
            w="100%"
            maxW="100%"
            h="100%"
            maxH="100%"
            overflow="auto"
        >
            <Table 
                size="sm"
                variant="striped"
                colorScheme='facebook'
            >
                <Thead>
                    <Tr>
                        <Th>Nombre</Th>
                        <Th>Email</Th>
                        <Th>Creación</Th>
                        <Th>Admin</Th>
                        <Th>Tiendas</Th>
                        <Th>Productos</Th>
                        <Th>Acciones</Th>
                    </Tr>
                </Thead>
                <Tbody>
                {users.map((user) => (
                    <Tr key={user._id}>
                        <Td>{user.name}</Td>
                        <Td>{user.email}</Td>
                        <Td>{formatDate(user.createdAt)}</Td>
                        <Td>{user.isAdmin ? 'Si' : 'No'}</Td>
                        <Td>{user.stores} / {user.slots}</Td>
                        <Td>{user.products} / {user.productsSlots} </Td>
                        <Td>
                            <Flex
                                justifyContent='flex-start'
                                alignItems='center'
                            >
                                <Tooltip label="Editar" aria-label="Editar">
                                    <Button
                                        mr='5px'
                                        size='sm'
                                        colorScheme='blue'
                                        variant='outline'
                                        borderRadius='50%'
                                        p='5px'
                                        isLoading={operationLoading}
                                        onClick={() => openEditUserModal(user)}
                                    >
                                        <IoPencil />
                                    </Button>
                                </Tooltip>
                                <Tooltip label="Eliminar" aria-label="Eliminar">
                                    <Button
                                        size='sm'
                                        colorScheme='red'
                                        variant='outline'
                                        borderRadius='50%'
                                        p='5px'
                                        onClick={() => deleteUserRequest(user._id)}
                                        isLoading={operationLoading}
                                    >
                                        <IoTrash />
                                    </Button>
                                </Tooltip>
                            </Flex>
                        </Td>
                    </Tr>
                ))}
                </Tbody>
            </Table>
            <Flex
                w='100%'
                justifyContent='space-between'
                alignItems='baseline'
            >
                <Flex
                    mt='20px'
                    justifyContent='start'
                    alignItems='baseline'
                >
                    <Button
                        fontSize={'.9rem'}
                        mr='5px'
                        size='xs'
                        colorScheme='blue'
                        variant='outline'
                        disabled={currentPage === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        <MdChevronLeft />
                    </Button>
                    <Button
                        fontSize={'.9rem'}
                        mr='10px'
                        size='xs'
                        colorScheme='blue'
                        variant='outline'
                        disabled={currentPage === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        <MdChevronRight />
                    </Button>
                    <Text
                        mt='20px'
                        fontSize='.9rem'
                    >
                        Pág. {currentPage} de {totalPages}
                    </Text>
                </Flex>
                <Button
                    fontSize={'.9rem'}
                    size='xs'
                    colorScheme='blue'
                    variant='outline'
                    onClick={openNewUserModal}
                >
                    Nuevo Usuario
                </Button>
            </Flex>
        </TableContainer>
    </Flex>
    );
}

export default UsersTable;